import { debounceTime, distinctUntilChanged, Subject } from "rxjs";
import { Component, EventEmitter, Output } from "@angular/core";
import { CivilianJurisdictionRepository, Jurisdiction } from "src/app/repositories/jurisdictions/civilian-jurisdiction-repository";
import { LinkUser, SharedUserLinkingRepository } from "@shared/src/public-api";
import { Router } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";

@Component({
	selector: "jhmc-connect-inmate",
	templateUrl: "./connect-inmate.component.html",
	styleUrls: ["./connect-inmate.component.scss"],
	imports: [MatFormFieldModule, MatInputModule, FormsModule]
})
export class ConnectInmateComponent
{
	@Output()
	public exit: EventEmitter<void> = new EventEmitter<void>();
	public jurisdictions: Jurisdiction[];
	public searchQueryUpdate: Subject<Event> = new Subject<Event>();
	public searchQuery: string;
	public selectedJurisdiction: Jurisdiction;
	public username: string;
	public password: string;
	public isConnecting: boolean;
	public isConnected: boolean;
	public isErrored: boolean;

	public constructor(
		private jurisdictionRepository: CivilianJurisdictionRepository,
		private userLinkingRepository: SharedUserLinkingRepository,
		private router: Router)
	{
		this.searchQueryUpdate.pipe(
			debounceTime(500),
			distinctUntilChanged())
			.subscribe(() =>
			{
				this.getJurisdictionsFromQuery();
			});
	}

	public cancel(): void
	{
		this.exit.emit();
	}

	public getJurisdictionsFromQuery(): void
	{
		this.jurisdictionRepository.searchJurisdictionsByName(this.searchQuery).subscribe((jurisdictions: Jurisdiction[]) =>
		{
			this.jurisdictions = jurisdictions;
		});
	}

	public selectJurisdiction(jurisdiction: Jurisdiction): void
	{
		this.selectedJurisdiction = jurisdiction;
	}

	public connectAccount(): void
	{
		this.isConnecting = true;
		const linkUser: LinkUser = new LinkUser(this.username, this.password);
		this.userLinkingRepository.linkUser(linkUser).subscribe((success: boolean) =>
		{
			if (success)
			{
				this.isConnecting = false;
				this.isConnected = true;
			}
			else
			{
				this.isConnecting = false;
				this.isErrored = true;
			}
		});
	}

	public goToInbox(): void
	{
		this.router.navigate(["/inbox"]);
	}

	public tryAgain(): void
	{
		this.isConnected = false;
		this.isErrored = false;
		this.isConnecting = false;
		this.selectedJurisdiction = null;
	}
}
